module.exports = __webpack_public_path__ + "6383a8259ffa36576d5101584e7b8f33.svg";